import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { CommunityApiService } from 'features/community/api/community-api.service';
import { UpdateBadgeDTO } from 'features/user-level/api/questions-api.service';
import { queryClient } from 'providers';

import { GroupTermQueryKeys } from './query.keys';
const { updateTerm } = CommunityApiService();
export const useUpdateTerm = () => {
  const { message } = App.useApp();

  return useMutation(
    (payload: UpdateBadgeDTO) => {
      return updateTerm(payload as any);
    },
    {
      onError: (error) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      onSuccess: (data, variables) => {
        Promise.all([
          queryClient.invalidateQueries({
            queryKey: GroupTermQueryKeys.lists(),
          }),
          queryClient.invalidateQueries({
            queryKey: GroupTermQueryKeys.detail(variables.id as any),
          }),
        ]);
        message.success('Udated Successfully');
      },
    },
  );
};
